import TotalItems from "./total-items";

export default TotalItems;